import React from 'react'
import { Helmet } from 'react-helmet-async'

interface SEOHeadProps {
  title?: string
  description?: string
  canonical?: string
  keywords?: string
}

export function SEOHead({
  title = "SAT Score Calculator | Digital SAT & Superscore Calculator",
  description = "Calculate your Digital SAT score, convert raw scores to scaled scores for Math and Reading, superscore your results, and convert ACT to SAT scores instantly.",
  canonical = "https://www.satscorescalculator.com",
  keywords = "sat score calculator, sat test score calculator, score calculator sat, estimate sat score, calculate my sat score, sat superscore calculator, digital sat calculator"
}: SEOHeadProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SAT Scores Calculator" />
      <meta property="og:image" content="https://www.satscorescalculator.com/og-image.jpg" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://www.satscorescalculator.com/og-image.jpg" />
    </Helmet>
  )
}
